import { _, debug, makeGtmCall } from '../utils.js'
import axios from 'axios'
import Loading from '../modules/loading.js'
import errorMessageContainer from '../templates/error.js'
import answers from '../templates/answers.js'
export default class Quiz {
    constructor(el) {
        this.el = el
        this.el.dataset.gtmEvent = 'compliance-test'
        this.resultsContainer = _('results-container', 'element').nodeFrom(
            this.el,
        )
        this.errorContainer = _('error-container', 'element').nodeFrom(this.el)
        this.timer = _('timer', 'element').nodeFrom(this.el)
        this.submitTriggers = _('submit-question').nodesFrom(this.el)
        this.skipTrigger = _('skip-question').nodeFrom(this.el)
        this.progress = _('progress', 'element').nodeFrom(this.el)
        this.progressBar = _('progress-bar', 'element').nodeFrom(this.el)
        this.defaultErrorMessage =
            'Something has gone quite wrong, please try to refresh your browser or contact us.'
        this.completedErrorMessage =
            'Sorry, there is no active test for this account, you may have already completed it.'
        this.passedErrorMessage =
            "You've already finished this test, and you passed."

        this.submitTriggers.map((submit) => {
            submit.addEventListener('click', this.submitAnswer)
        })
        this.skipTrigger.addEventListener('click', this.skipQuestion)
        this.countdownOn = false
        this.getStatus()
    }

    showLoading = () => {
        this.resultsContainer.innerHTML =
            '<div class="loading" data-behaviour="loading"></div>'
        _('loading')
            .nodes()
            .map((el) => new Loading(el))
    }

    hideLoading = () => {
        this.resultsContainer.innerHTML = ''
    }

    getStatus = () => {
        this.showLoading()
        axios({
            method: 'get',
            url: '/api/compliance-test/status',
        })
            .then((response) => {
                if (response.status !== 200) {
                    return this.handleError(response)
                }

                if (response.data.result.testDetails.passed === true) {
                    this.el.dataset.gtmCompletionType = 'test passed'
                    makeGtmCall(this.el)
                    return this.goToResultsPage()
                }

                if (response.data.result.testDetails.passed === false) {
                    this.el.dataset.gtmCompletionType = 'test failed'
                    makeGtmCall(this.el)
                    return this.startNewTest()
                }

                this.setDate(response.data.result)
                this.getQuestions(
                    response.data.result.nextQuestionId,
                    response.data.result.testDetails.answeredCount,
                )
            })
            .catch((error) => {
                this.handleError(error)
            })
    }

    startNewTest = () => {
        axios({
            method: 'post',
            url: '/api/compliance-test/new',
        })
            .then((response) => {
                if (response.status !== 200) {
                    return this.handleError(response)
                }
                this.getStatus()
            })
            .catch((error) => {
                this.handleError(error)
            })
    }

    getQuestions = (questionId, answeredQuestions) => {
        if (!questionId) {
            if (debug) {
                console.warn('no question id')
            }
            return this.handleError(0)
        }
        axios({
            method: 'get',
            url: '/api/compliance-test/questions',
        })
            .then((response) => {
                if (response.status !== 200) {
                    return this.handleError(response)
                }

                this.showQuestion(response.data, questionId)

                this.updateProgressBar(
                    response.data.result.data.length,
                    answeredQuestions,
                )
                this.el.classList.add('quiz--active')
            })
            .catch((error) => {
                this.handleError(error)
            })
    }

    /**
     * @param  {object} response - api response
     * @param  {number} questionId
     */

    showQuestion = (response, questionId) => {
        let resultsHTML = ''
        response.result.data.map((question) => {
            if (question.id === questionId) {
                this.skipTrigger.classList.toggle(
                    'u-hidden',
                    !question.skippable,
                )
                resultsHTML += `<h2 class="heading--4 u-mb-double">${question.questionText}</h2>`
                resultsHTML += `<input type="hidden" value="${questionId}" name="questionId" data-element="input">`

                question.availableAnswers.map((el) => {
                    resultsHTML += answers(el)
                })
                this.resultsContainer.innerHTML = resultsHTML
            }
        })
    }

    /**
     * @param  {number} maxQuestions
     * @param  {number} answeredQuestions
     */

    updateProgressBar = (maxQuestions, answeredQuestions) => {
        const total = parseFloat(
            (answeredQuestions / maxQuestions) * 100,
        ).toFixed(0)

        _('max-questions', 'element').nodeFrom(this.el).innerHTML = maxQuestions
        _('answered-questions', 'element').nodeFrom(this.el).innerHTML =
            answeredQuestions

        this.progressBar.setAttribute('max', maxQuestions)
        this.progressBar.setAttribute('value', answeredQuestions)
        this.progressBar.innerHTML = `${total}%`
        this.progress.classList.remove('u-hidden')
    }

    skipQuestion = (e) => {
        this.submitAnswer(e, true)
    }

    /**
     * @param  {object} e
     * @param  {boolean} skip - whether question can be skipped.
     */

    submitAnswer = (e, skip = false) => {
        this.errorContainer.innerHTML = ''
        const inputs = _('input', 'element').nodesFrom(this.resultsContainer)

        let endpoint = '/api/compliance-test/answer'
        let blankValidation = true
        inputs.map((el, i) => {
            if (!i) {
                endpoint += '?'
            }
            if (el.type !== 'radio' && el.type !== 'checkbox') {
                endpoint += `&${el.getAttribute('name')}=${el.value}`
            }
            if (el.type === 'radio' && el.checked) {
                endpoint += `&${el.getAttribute('name')}=${el.value}`
            }
            if (el.type === 'checkbox' && el.checked) {
                endpoint += `&${el.getAttribute('name')}=${el.value}`
                blankValidation = false
            }
        })
        if (skip) {
            endpoint += '&skip=true'
        }
        if (blankValidation && !skip) {
            this.errorContainer.innerHTML = errorMessageContainer(
                'Please answer the question',
            )

            return false
        }
        axios({
            method: 'post',
            url: endpoint,
        })
            .then((response) => {
                if (response.status !== 200) {
                    return this.handleError(response)
                }

                this.getStatus()
            })
            .catch((error) => {
                this.handleError(error)
            })
    }

    setDate = (response) => {
        const startDate = new Date(response.testDetails.startedOn)
        const startMonth = ('0' + startDate.getMonth()).slice(-2)
        const startDay = ('0' + startDate.getDate()).slice(-2)
        const startDateText = `${startDay}/${startMonth}/${startDate.getFullYear()} - ${startDate.getHours()}:${startDate.getMinutes()}`
        _('start-date', 'element').nodeFrom(
            this.el,
        ).innerHTML = `Started: ${startDateText}`
        this.startCountdown(startDate)

        if (response.testDetails.lastSaved) {
            const savedDate = new Date(response.testDetails.lastSaved)
            const savedMonth = ('0' + savedDate.getMonth()).slice(-2)
            const savedDay = ('0' + savedDate.getDate()).slice(-2)
            const savedDateText = `${savedDay}/${savedMonth}/${savedDate.getFullYear()} - ${savedDate.getHours()}:${savedDate.getMinutes()}`

            _('last-saved', 'element').nodeFrom(
                this.el,
            ).innerHTML = `Last saved: ${savedDateText}`
        }
    }

    /**
     * @param  {Date} startDate
     */

    startCountdown = (startDate) => {
        if (this.countdownOn) {
            return false
        } else {
            this.countdownOn = true
        }

        let deadline = new Date()
        deadline.setTime(startDate.getTime())
        deadline.setDate(startDate.getDate() + 1) // 24 hours to complete the test
        deadline = new Date(deadline).getTime()
        const countdown = setInterval(() => {
            const now = new Date().getTime()
            const time = deadline - now
            const days = Math.floor(time / (1000 * 60 * 60 * 24))
            const hours = Math.floor(
                (time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
            )
            const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
            const seconds = Math.floor((time % (1000 * 60)) / 1000)

            _('hours', 'element').nodeFrom(this.el).innerHTML = (
                '0' +
                (days * 24 + hours)
            ).slice(-2)

            _('minutes', 'element').nodeFrom(this.el).innerHTML = (
                '0' + minutes
            ).slice(-2)
            _('seconds', 'element').nodeFrom(this.el).innerHTML = (
                '0' + seconds
            ).slice(-2)
            if (time < 0) {
                clearInterval(countdown)
                this.timer.innerHTML = 'TIME UP'
            }
        }, 1000)

        setTimeout(() => {
            this.timer.classList.remove('u-hidden')
        }, 1000)
    }

    handleError = (err, defaultMessage = this.defaultErrorMessage) => {
        if (debug) {
            console.warn({ err })
        }

        if (err && err.response && err.response.status === 400) {
            if (debug) {
                console.warn('400: no active test')
            }
            this.el.dataset.gtmCompletionType = '400: no active test'
            makeGtmCall(this.el)
            return this.startNewTest()
        }
        if (err && err.response && err.response.status === 401) {
            if (debug) {
                console.warn('401: not logged in')
            }
            this.el.dataset.gtmCompletionType = '401: not logged in'
            makeGtmCall(this.el)
            return this.goToResultsPage()
        }
        if (err && err.response && err.response.status === 424) {
            if (debug) {
                console.warn('424: red flag fail')
            }
            this.el.dataset.gtmCompletionType = '424: red flag fail'
            makeGtmCall(this.el)
            return this.goToResultsPage()
        }
        if (err && err.response && err.response.status === 423) {
            if (debug) {
                console.warn('423: max amounts of attempts')
                this.el.dataset.gtmCompletionType =
                    '423: max amounts of attempts'
                makeGtmCall(this.el)
            }
            return this.goToResultsPage()
        }

        let errorHTML = `<p>${defaultMessage}</p>`
        if (err && err.response && err.response.data.error) {
            errorHTML = `<p>${err.response.data.error}</p>`
        }
        this.resultsContainer.innerHTML = errorMessageContainer(errorHTML)
    }

    goToResultsPage = () => {
        window.location.href = '/compliance/compliance-results'
    }
}
